import Response from '@/shared/types/response';
import ShippingProfile from '@/shared/types/shipping/shippingProfile.type';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type Args = {
  id: string;
  body: Partial<ShippingProfile>;
  onUnauthorized?: () => void;
};

const updateShippingProfile = async ({ id, body, onUnauthorized }: Args) => {
  const token = getCookie('auth_token');

  try {
    return await fetcher<Response<ShippingProfile[]>>({
      url: `/shipping/profiles/${id}/`,
      method: 'PUT',
      body,
      token,
      onUnauthorized,
    });
  } catch (error) {
    console.error(
      'Error occurred in function "updateShippingProfile" in file "src/shared/api/shipping/profiles/updateShippingProfile.ts":',
      error,
    );
    return error as Response<ShippingProfile[]>;
  }
};

export default updateShippingProfile;
